exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".styles__type_icon--_N-6P {\n  height: 24px; }\n", "",{"version":3,"sources":["/Users/diegomartin/Documents/GitHub/dashboard/src/components/PlatformIcons/styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAY,EAAA","file":"styles.scss","sourcesContent":[".type_icon {\n    height: 24px;\n}\n"],"sourceRoot":""}]);

// Exports
exports.locals = {
	"type_icon": "styles__type_icon--_N-6P"
};